<div class="wrapper">
  <ion-icon [name]="icon"></ion-icon>
  <p>{{message}}</p>
</div>
